import { InitDetail } from "lightgallery/lg-events";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import LightGalleryComponent from "lightgallery/react";

import { AssetUrl, Edits, assertVaultUrl, assetUrlToVaultUrl } from "@holibob-packages/vault";

import { LIGHT_GALLERY_LICENSE_KEY } from "../product/lightGalleryConfig";
import { SrcFactory, computeImageSrcSetProperties } from "../utils";

type LightGalleryImageProps = {
    assetUrlList: AssetUrl[];
    allowDownload?: boolean;
    onInit?: ((detail: InitDetail) => void) | undefined;
};
export function LightGalleryImage(props: LightGalleryImageProps) {
    const { assetUrlList, allowDownload, onInit } = props;

    const dynamicEl = useDynamicEl(assetUrlList);

    return (
        <LightGalleryComponent
            onInit={onInit}
            plugins={[lgThumbnail, lgZoom]}
            licenseKey={LIGHT_GALLERY_LICENSE_KEY}
            download={allowDownload}
            dynamic={true}
            loop={false}
            dynamicEl={dynamicEl}
        />
    );
}

function useDynamicEl(assetUrlList: AssetUrl[]) {
    return assetUrlList.map((assetUrl) => {
        const vaultUrl = assetUrlToVaultUrl(assetUrl);
        assertVaultUrl(vaultUrl);

        const srcFactory: SrcFactory = ({ width, height }) => {
            const edits: Partial<Edits> = {
                resize: {
                    fit: "cover",
                    width,
                    height,
                },
            };
            return vaultUrl.modifyEdits(edits).toString();
        };

        const sizes = [300, 600, 900, 1280, 1200, 1536, 2048, 2560, 3440, 3840, 4096];

        const { src, srcSet } = computeImageSrcSetProperties(sizes, { srcFactory });
        const thumb = srcFactory({ width: 200, height: 200 });

        return { src, srcSet, thumb };
    });
}
